import { fromJS } from 'immutable';
import { NavMarker } from 'react-rhumb';
import { AGGREGATION } from 'reporting-data/constants/configTypes';
import { ANALYTICS_ALL_PAGES } from 'reporting-data/constants/dataTypes';
import { BAR } from 'reporting-data/constants/chartTypes';
import { IN } from 'reporting-data/constants/operators';
import PlatformReportResolver from 'reporting-ui-components/components/PlatformReport/PlatformReportResolver';
import { ALL_METRICS, MAB_VARIATION_COLORS } from '../../constants/reporting';
import { jsx as _jsx } from "react/jsx-runtime";
const getReport = ({
  dateRange,
  mabMetric,
  variantIds
}) => {
  const customColors = variantIds.length <= MAB_VARIATION_COLORS.length ? variantIds.map((id, index) => [id, MAB_VARIATION_COLORS[index]]) : {};
  return fromJS({
    chartType: BAR,
    config: {
      configType: AGGREGATION,
      dataType: ANALYTICS_ALL_PAGES,
      dimensions: ['id'],
      filters: {
        custom: [{
          operator: IN,
          property: 'filters',
          values: variantIds
        }],
        dateRange: {
          property: 'sessionDate',
          value: dateRange
        }
      },
      metrics: [{
        metricTypes: ALL_METRICS[mabMetric].metricTypes,
        property: mabMetric
      }]
    },
    displayParams: {
      colors: {
        custom: customColors
      },
      hideLegend: true,
      hideMarkers: true,
      rhumbConfig: {
        renderSuccessMarker: () => /*#__PURE__*/_jsx(NavMarker, {
          name: "MAB_CHART_LOADED"
        })
      },
      seriesOrder: {
        type: 'static',
        values: variantIds
      },
      xAxis: {
        title: {
          enabled: false
        }
      },
      yAxis: {
        title: {
          enabled: false
        }
      }
    },
    v2: true
  });
};
const MABChart = ({
  dateRange,
  mabMetric,
  onWinnersChange,
  onMABReportMetricsChange,
  onNoData,
  variantIds
}) => {
  const report = getReport({
    variantIds,
    dateRange,
    mabMetric
  });
  const handleReportResolve = ({
    hasData,
    data
  }) => {
    if (!hasData) {
      onNoData();
      return;
    }
    const metricName = `PERCENTILES|${mabMetric}`;
    const pathToProperties = ['primary', 'data', 'properties'];
    const orderedVariants = data.getIn(['primary', 'data', 'data']).sortBy(bucket => -bucket.get(metricName));
    const orderedVariationsWithMetrics = orderedVariants.map(variation => ({
      id: variation.get('id'),
      metricLabel: data.getIn([...pathToProperties, metricName, 'label']),
      metricValue: variation.get(metricName),
      name: data.getIn([...pathToProperties, 'id', 'references', variation.get('id'), 'label'])
    })).toArray();
    onMABReportMetricsChange(orderedVariationsWithMetrics);
    const highestSubmissionRate = orderedVariants.first().get(metricName);
    const winnerIds = orderedVariants.filter(variant => variant.get(metricName) === highestSubmissionRate).map(variant => variant.get('id')).toArray();
    onWinnersChange(winnerIds);
  };
  if (!report) {
    return null;
  }
  return /*#__PURE__*/_jsx(PlatformReportResolver, {
    onReportResolve: handleReportResolve,
    report: report,
    useInlineLabels: false
  });
};
export default MABChart;